import type React from 'react';

const BackgroundImage: React.FC = () => {
  return (
    <div className="relative flex-1">
      <img
        alt="Background"
        className="object-cover absolute inset-0 w-full h-full"
        src="/assets/opentable/images/login.webp"
      />
    </div>
  );
};

export default BackgroundImage;
